import { getProductPrice } from 'shared-utils'
import { type ICartItemFlat, type CartItem } from 'ecosystem'

/**
 * Helper function to get the price from a cart item
 * @param cartItem - The cart item to extract price from
 * @returns The price of the item or 0 if not found
 */
export const getCartItemPrice = (cartItem: CartItem): number => {
  if (cartItem.type === 'SINGLE') {
    return getProductPrice(cartItem.meta.singleType.product)
  } else if (cartItem.type === 'GROUP') {
    // For group items, sum up all the prices of items in the group
    return cartItem.meta.groupType.items.reduce((total, item) => {
      const itemPrice = getProductPrice(item.product)
      const itemQty = item.qty || 1
      return total + itemPrice * itemQty
    }, 0)
  }
  return 0
}

/**
 * Helper function to flatten cart items into a consistent format
 * @param items - Cart items to flatten
 * @returns Array of flattened cart items
 */
export const flattenCartItems = (items: CartItem[]): ICartItemFlat[] => {
  const flatItems: ICartItemFlat[] = []

  items.forEach((item) => {
    if (item.type === 'SINGLE') {
      flatItems.push({
        cartItemId: item.id,
        qty: item.qty,
        product: item.meta.singleType.product,
        subItems: item.meta.singleType.subItems
      })
    } else if (item.type === 'GROUP') {
      // For group items, we need to handle each item in the group
      item.meta.groupType.items.forEach((groupItem) => {
        flatItems.push({
          cartItemId: item.id,
          qty: groupItem.qty || item.qty,
          product: groupItem.product,
          subItems: groupItem.subItems
        })
      })
    }
  })

  return flatItems
}
